import {deviceReachability} from '../../core/deviceReachability';

/**
 * Serialize Access Point context for the agent API.
 *
 * The TIP flag is not here: it belongs to the Site, and both serializers
 * write the same key into one merged object, so whichever ran last decided
 * it. serializeSiteContext owns it now.
 * @param {object} context mounted page context
 * @return {object} public Access Point context
 */
export function serializeAccessPointContext(context) {
	const route = context.route?.toLowerCase();
	const hasAccessPointContext = route === '/accesspointdashboard';
	const apId = context.ap_id ?? context.apId;
	const apName = context.ap_name ?? context.apName;
	return {
		...deviceReachability(hasAccessPointContext, context.target_online),
		ap_id: hasAccessPointContext &&
			typeof apId === 'string' &&
			apId
			? apId
			: null,
		ap_name: hasAccessPointContext &&
			typeof apName === 'string' &&
			apName
			? apName
			: null,
	};
}
